import Vue from "vue";
import Router from "vue-router";
import VueKinesis from "vue-kinesis";
import VueScrollTo from "vue-scrollto";
import VueScrollmagic from "vue-scrollmagic";
import LandingPage from "@/components/templates/LandingPage";

Vue.use(Router);

Vue.use(VueScrollTo, {
  container: "body",
  duration: 500,
  easing: "ease",
  offset: 0,
  force: true,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true
});
export default new Router({
  routes: [
    {
      path: "/",
      name: "LandingPage",
      component: LandingPage
    }
  ]
});

Vue.use(VueScrollmagic);

Vue.use(VueKinesis);



// WEBPACK FOOTER //
// ./src/router/index.js